import { priceSystem } from '@/api/index'

export function DeleteCustomerSignPrice (data) {
  return priceSystem.request({
    method: 'post',
    url: '/DeleteCustomerSignPrice',
    data
  })
}

export function InitCustomerSignTemplateData (data) {
  return priceSystem.request({
    method: 'post',
    url: '/InitCustomerSignTemplateData',
    data,
    iSFromData: true
  })
}

export function SaveCostomerSignPriceData (data) {
  return priceSystem.request({
    method: 'post',
    url: '/SaveCostomerSignPriceData',
    data,
    iSFromData: true
  })
}

export function SaveEditCustomerPrice (data) {
  return priceSystem.request({
    method: 'post',
    url: '/SaveEditCustomerPrice',
    data
  })
}
